import Dropdown from './dropdown';
import DropdownButton from './dropdown-button';
Dropdown.Button = DropdownButton;
export default Dropdown;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ../~/_antd@3.23.4@antd/es/dropdown/index.js
// module id = 195
// module chunks = 0